export const REFERENCE_PRS_URL = 'https://pubmed.ncbi.nlm.nih.gov/30554720/'
